import { Component, inject } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { MyProgressService } from '../../../../api/api-services/my-progress.service';

@Component({
  selector: 'app-invite-student',
  templateUrl: './invite-student.component.html',
  styleUrl: './invite-student.component.scss'
})
export class InviteStudentComponent {
  private _dialogRef = inject(DynamicDialogRef);
  private _myProgressService = inject(MyProgressService);
  public oskShortCode = 'oskShortCode'
  ngOnInit(): void {
    this._myProgressService.get().subscribe({
      next: (res) => {
        this.oskShortCode = res.oskShortCode ?? 'oskShortCode'
      }
    })
  }
  closeDialog() {
    this._dialogRef.close(status);
  }

  copyLink(): void {
    const text = `https://testy-na-prawko.net/app/join/${this.oskShortCode}`;
    this.copyToClipboard(text)
  }

  private copyToClipboard(text: string): void {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text).then(
        () => {
          console.log('Copied to clipboard:', text);
        },
        (err) => {
          console.error('Failed to copy:', err);
        }
      );
    } else {
      // Fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      try {
        document.execCommand('copy');
        console.log('Copied to clipboard (fallback):', text);
      } catch (err) {
        console.error('Failed to copy (fallback):', err);
      }
      document.body.removeChild(textarea);
    }
  }
}
